import colors from '../foundation/colors';

import { popoverMenuButtonStyles } from './popoverMenuButtonStyles';

export const getPrimaryButtonStyles = (currentValue, isOpen) => {
  let style = { ...popoverMenuButtonStyles, width: '100%', color: colors.greyScale['500'] };
  if (currentValue) style = { ...popoverMenuButtonStyles, color: colors.greyScale['900'] };
  if (isOpen) {
    style = {
      ...popoverMenuButtonStyles,
      color: colors.primaryScale['600'],
      borderColor: colors.primaryScale['600'],
      boxShadow: `inset 0 0 0 1px ${colors.primaryScale['600']}`
    };
  }

  return style;
};

export const getSecondaryButtonStyles = isOpen => {
  let style = {
    ...popoverMenuButtonStyles,
    background: colors.primaryScale['50'],
    color: colors.primaryScale['600'],
    fontWeight: '500'
  };

  if (isOpen) {
    style = {
      ...popoverMenuButtonStyles,
      background: colors.primaryScale['50'],
      color: colors.primaryScale['600'],
      fontWeight: '500',
      borderColor: colors.primaryScale['600'],
      boxShadow: `inset 0 0 0 1px ${colors.primaryScale['600']}`
    };
  }

  return style;
};

export const getButtonVariantStyles = (variant, isOpen, currentValue) => {
  switch (variant) {
    case 'primary': {
      return getPrimaryButtonStyles(currentValue, isOpen);
    }

    case 'secondary': {
      return getSecondaryButtonStyles(isOpen);
    }

    default: {
      return getPrimaryButtonStyles(currentValue, isOpen);
    }
  }
};
